<template>
  <div class="detail-pc" v-if='data'>
    <div class="pc-wrap">
      <!-- <div class="header">
        <a href="http://ego.geekbang.org/"><img src="./assets/logo.png" alt="logo"></a>
        <div class="header-right">
          <span>加入 EGO，与全球杰出技术领<br v-if='width < 950'/>袖为伍，冲破局限，共同成长</span>
          <button type="button" name="button"><a href="http://ego.geekbang.org/together">加入我们</a></button>
        </div>
      </div> -->

      <div class="info-card">
        <div class="info-header">
          <img :src="data.photo" alt="avatar">
          <h1>{{data.name}}</h1>
        </div>

        <hr />

        <div class="info-content">
          <div class="left">
            <div class="item">
              <p class='type'>职位</p>
              <p class='value'>{{ data.position || '-' }}</p>
            </div>
            <div class="item">
              <p class='type'>所属公司</p>
              <p class='value'>{{ data.firm || '-' }}</p>
            </div>
            <div class="item">
              <p class='type'>所属地区</p>
              <p class='value'>{{ data.joinCity || '-' }}</p>
            </div>
            <div class="item">
              <p class='type'>入会时间</p>
              <p class='value'>{{ data.joinTime | parseDate }}</p>
            </div>
            <div class="item">
              <p class='type'>行业领域</p>
              <p class='value'>{{ data.memberTags || '-'}}</p>
            </div>
          </div>
          <div class="right">
            <div class="nav">
              <span v-show='data.introduce' :class='{"active": !nav}' class='left' @click='nav=0'>职业背景</span>
              <span v-show='data.memberInterview' :class='{"active": nav}' class='right' @click='nav=1'>人物访谈</span>
            </div>
            <div v-if='nav' class="interview">
              <div v-for='(item, i) in data.memberInterview' :key='i' class='item'>
                <h1>{{item.title}}</h1>
                <div v-html='item.contents'></div>
                <a :href='item.link' target='_blank' class='more'>了解更多>></a >
              </div>
            </div>
            <div v-else class="introduce" v-html='data.introduce'></div>
          </div>
        </div>

      </div>

      <!-- <div class="footer">
        <p>&copy; 2017 Geekbang Technology Ltd. All rights reserved.</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'pc',
  data () {
    return {
      nav: 0,
      width: 1500
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  created () {
    this.width = window.innerWidth
  },
  filters: {
    parseDate (value) {
      let date = new Date(value * 1000)
      let month = date.getMonth() > 9 ? date.getMonth() : `0${date.getMonth()}`
      let day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
      return date.getFullYear() + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="sass">
@import "./assets/css/variable"

.detail-pc
  width: 100%
  background: url('./assets/bg-pc.jpg') no-repeat
  background-size: 100% 100%
  background-position: bottom
  padding: 100px 0
  .pc-wrap
    width: 85%
    max-width: 1227px
    margin: 0 auto
    .header
      display: flex
      height: 127px
      align-items: center
      justify-content: space-between
      img
        height: 42px
        margin-right: 40px
      .header-right
        font-size: 18px
        display: flex
        align-items: center
        span
          color: #9a9a9a
          text-align: right
        button
          flex-shrink: 0
          font-size: 16px
          border-radius: 4px
          border: 1px solid #D7B375
          background-color: transparent
          margin-left: 26px
          padding: 10px 22px
          transition: all 0.5s
          cursor: pointer
          &:active, &:visited, &:hover, &:focus
            outline: none
            box-shadow: 0 0 3px rgba(0,0,0,.2) inset
          a
            color: #D7B375
    .info-card
      background: rgba(255, 255, 255, .4)
      padding: 64px 72px
      border-radius: 30px
      .info-header
        display: flex
        align-items: center
        height: 120px
        margin-bottom: 40px
        img
          width: 120px
          height: 120px
          border-radius: 50%
        h1
          font-size: 30px
          color: #666666
          margin-left: 27px
      hr
        border-top: 1px solid #9a9a9a
      .info-content
        display: flex
        margin-top: 40px
        .left
          flex-basis: 292px
          flex-shrink: 0
          .item
            padding: 0 10px
            color: #6a6a6a
            margin-bottom: 40px
            .type
              font-size: 14px
              padding: 4px 0
              font-weight: bold
              &:first-child
                padding-top: 0
            .value
              font-size: 16px
              padding: 10px 0
        .right
          color: #303030
          .nav
            height: 45px
            margin-bottom: 45px
            span
              font-weight: 500
              font-size: 18px
              padding-bottom: 20px
              cursor: pointer
              color: #353535
              &.active
                border-bottom: 2px solid #D7B375
              &.left
                margin-right: 60px
          .introduce
            p
              color: #6a6a6a
              font-size: 16px
              line-height: 24px
              margin-bottom: 30px
              letter-spacing: .5px
              text-align: justify
          .interview
            .item
              margin-bottom: 34px
              border-bottom: 1px solid #e8e8e8
              &:last-child
                border-bottom: none
              h1
                font-size: 18px
                margin-bottom: 15px
              div
                p
                  color: #6a6a6a
                  font-size: 16px
                  line-height: 24px
                  letter-spacing: .5px
                  text-align: justify
              .more
                padding: 4px 0
                display: inline-block
                color: #D7B375
                font-size: 16px
                margin: 10px 0 30px
                cursor: pointer
    .footer
      text-align: center
      margin-top: 94px
      padding-bottom: 37px
      font-size: 16px
      color: #666666
      opacity: .7

@media (max-width: 950px)
  .nav .left
    margin-right: 50px !important
</style>
